export default {
  TYPE_NORMAL: 1,
  TYPE_FLEXIBLE: 2,
  TYPE_CUSTOM: 3,
}